import React from 'react';

import { UserManagementUserType } from './types';
import UserManagementMultipleUsersFeatureFlagsModal from './UserManagementMultipleUsersFeatureFlagsModal';
import UserManagementSingleUserFeatureFlagsModal from './UserManagementSingleUserFeatureFlagsModal';

type Props = {
  open: boolean;
  onClose: () => void;
  user?: UserManagementUserType;
  users?: UserManagementUserType[];
  onSaved?: () => void;
};

const EMPTY_USERS: UserManagementUserType[] = [];

const UserManagementFeatureFlagsModal = ({ open, onClose, user, users = EMPTY_USERS, onSaved }: Props) => {
  if (users.length > 0) {
    return (
      <UserManagementMultipleUsersFeatureFlagsModal open={open} onClose={onClose} users={users} onSaved={onSaved} />
    );
  }

  return <UserManagementSingleUserFeatureFlagsModal open={open} onClose={onClose} user={user} onSaved={onSaved} />;
};

export default UserManagementFeatureFlagsModal;
